import * as Mui from "@mui/material";
import FormInput from "../../common/FormInput";
import DeliveryNotesInfoType from "../../../types/DeliveryNotesInfoType";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import { useContext, useEffect, useState } from "react";
import OperationTypes from "../../../types";
import DeliveryNoteService from "../service/DeliveryNoteServices";
import { ContextOperation } from "../../../context/OperationContext";

type Props = {
  index: number;
  deliveryNotesInfo: DeliveryNotesInfoType;
}

const DeliveryNoteVehiclesDetails = (props: Props) => {
  const { tenant } = useContext(ContextOperation);

  const [damages, setDamages] = useState<OperationTypes.Damage[]>([]);
  const [missingEquipments, setMissingEquipments] = useState<OperationTypes.Equipmet[]>([]);

  const t = useOperationTranslation();

  useEffect(() => {
    if (props.deliveryNotesInfo) {
      let idDamages: (number | undefined)[] = [];
      let idEquipments: (number | undefined)[] = [];

      props.deliveryNotesInfo.vehicleOpenDamages?.forEach(element => idDamages.push(element.openDamageId));

      props.deliveryNotesInfo.vehicleOpenDamageEquipments?.forEach(element => idEquipments.push(element.openDamageEquipmentId));
      
      if (idDamages?.length > 0) {
        DeliveryNoteService.get.damageDetailsbyid(tenant, idDamages).then(
          (response) => setDamages(response)
        )
      }

      if (idEquipments?.length > 0) {
        DeliveryNoteService.get.equipmentDetailsbyid(tenant, idEquipments).then(
          (response) => setMissingEquipments(response)
        )
      }
    }
  }, []);

  return (
    <Mui.Box key={`props.deliveryNotesInfo-box-${props.index}`} mb={2}>
      <Mui.Card key={`props.deliveryNotesInfo-card-${props.index}`}>
        <Mui.CardContent key={`vehicles-card-content-${props.index}`}>
          <Mui.Grid
            container
            key={`vehicles-grid-content-${props.index}`}
            columns={12}
            alignItems="center"
            spacing={2.5}
            rowGap={4}
            mb={4}
          >
            <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <FormInput
                name="vin"
                label={t(
                  "deliveryNote.deliveryDetails.tab.deliveryNoteInfo.vin"
                )}
                value={props.deliveryNotesInfo?.vin || ""}
                type="text"
                disabled
                fullWidth
              />
            </Mui.Grid>

            <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <FormInput
                name="licensePlate"
                label={t(
                  "deliveryNote.deliveryDetails.tab.deliveryNoteInfo.plate"
                )}
                value={props.deliveryNotesInfo?.licensePlate || ""}
                type="text"
                disabled
                fullWidth
              />
            </Mui.Grid>

            <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <FormInput
                name="brand"
                label={t("transferReason.details.tab3.brand")}
                value={props.deliveryNotesInfo?.brand || ""}
                type="text"
                disabled
                fullWidth
              />
            </Mui.Grid>

            <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <FormInput
                name="model"
                label={t("transferReason.details.tab3.model")}
                value={props.deliveryNotesInfo?.model || ""}
                type="text"
                disabled
                fullWidth
              />
            </Mui.Grid>

            <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <FormInput
                name="carSegment"
                label={t("transferReason.details.tab3.carSegment")}
                value={props.deliveryNotesInfo?.carSegment || ""}
                type="text"
                disabled
                fullWidth
              />
            </Mui.Grid>

            <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <FormInput
                name="carClass"
                label={t("transferReason.details.tab3.carClass")}
                value={props.deliveryNotesInfo?.carClass || ""}
                type="text"
                disabled
                fullWidth
              />
            </Mui.Grid>

            <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <FormInput
                name="acriss"
                label={t("transferReason.details.tab3.acriss")}
                value={props.deliveryNotesInfo?.acriss || ""}
                type="text"
                disabled
                fullWidth
              />
            </Mui.Grid>

            <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <FormInput
                name="customAcriss"
                label={t("transferReason.details.tab3.customAcriss")}
                value={props.deliveryNotesInfo?.customAcriss || ""}
                type="text"
                disabled
                fullWidth
              />
            </Mui.Grid>

            <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <FormInput
                name="carCompany"
                label={t("transferReason.details.tab3.carCompany")}
                value={props.deliveryNotesInfo?.carCompany || ""}
                type="text"
                disabled
                fullWidth
              />
            </Mui.Grid>

            <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <FormInput
                name="departureKm"
                label={t(
                  "deliveryNote.deliveryDetails.tab.deliveryNoteInfo.departureKm"
                )}
                value={
                  props.deliveryNotesInfo?.departureKm !== undefined
                    ? props.deliveryNotesInfo?.departureKm
                    : ""
                }
                type="text"
                disabled
                fullWidth
              />
            </Mui.Grid>

            <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <FormInput
                name="departureThermicFuel"
                label={t(
                  "deliveryNote.deliveryDetails.tab.deliveryNoteInfo.departureFuelLevel"
                )}
                value={
                  props.deliveryNotesInfo?.departureThermicFuel !== undefined
                    ? `${props.deliveryNotesInfo?.departureThermicFuel}/8`
                    : ""
                }
                type="text"
                disabled
                fullWidth
              />
            </Mui.Grid>

            <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <FormInput
                name="departureElectricLevel"
                label={t(
                  "deliveryNote.deliveryDetails.tab.deliveryNoteInfo.departureBatteryLevel"
                )}
                value={
                  props.deliveryNotesInfo?.departureElectricLevel !== undefined
                    ? `${props.deliveryNotesInfo?.departureElectricLevel}%`
                    : ""
                }
                type="text"
                disabled
                fullWidth
              />
            </Mui.Grid>

            <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <FormInput
                name="arrivalKm"
                label={t(
                  "deliveryNote.deliveryDetails.tab.deliveryNoteInfo.arrivalKm"
                )}
                value={
                  props.deliveryNotesInfo?.arrivalKm !== undefined
                    ? props.deliveryNotesInfo?.arrivalKm
                    : ""
                }
                type="text"
                disabled
                fullWidth
              />
            </Mui.Grid>

            <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <FormInput
                name="arrivalThermicFuel"
                label={t(
                  "deliveryNote.deliveryDetails.tab.deliveryNoteInfo.arrivalFuelLevel"
                )}
                value={
                  props.deliveryNotesInfo?.arrivalThermicFuel !== undefined
                    ? `${props.deliveryNotesInfo?.arrivalThermicFuel}/8`
                    : ""
                }
                type="text"
                disabled
                fullWidth
              />
            </Mui.Grid>

            <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <FormInput
                name="arrivalElectricLevel"
                label={t(
                  "deliveryNote.deliveryDetails.tab.deliveryNoteInfo.arrivalBatteryLevel"
                )}
                value={
                  props.deliveryNotesInfo?.arrivalElectricLevel !== undefined
                    ? `${props.deliveryNotesInfo?.arrivalElectricLevel}%`
                    : ""
                }
                type="text"
                disabled
                fullWidth
              />
            </Mui.Grid>
            <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
              <FormInput
                name="loadprops.index"
                label={t("deliveryNote.deliveryDetails.tab.deliveryNoteInfo.loadIndex")}
                value={
                  props.deliveryNotesInfo?.weight !== undefined
                    ? props.deliveryNotesInfo?.weight
                    : ""
                }
                type="text"
                disabled
                fullWidth
              />
            </Mui.Grid>
          </Mui.Grid>

          {/* <Mui.Typography>
            {t(
              "deliveryNote.deliveryDetails.tab.deliveryNoteInfo.damageForms"
            )}
          </Mui.Typography>
          <Mui.Grid
            container
            key={`vehicles-damage-form-grid-content-${props.index}`}
            columns={12}
            alignItems="center"
            spacing={2.5}
            rowGap={4}
            mb={4}
          >
            {props.deliveryNotesInfo !== undefined &&
            props.deliveryNotesInfo?.vehicleDamageForms != undefined &&
            props.deliveryNotesInfo?.vehicleDamageForms?.length > 0 ? (
              props.deliveryNotesInfo?.vehicleDamageForms?.map(
                (damageForm, i) => {
                  return (
                    <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                      <FormInput
                        name={`damageForm-${i}`}
                        label={t(
                          "deliveryNote.deliveryDetails.tab.deliveryNoteInfo.damageFormsId"
                        )}
                        value={
                          damageForm?.damageFormId !== undefined
                            ? damageForm?.damageFormId
                            : ""
                        }
                        type="text"
                        disabled
                        fullWidth
                      />
                    </Mui.Grid>
                  );
                }
              )
            ) : (
              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <Mui.Typography variant="subtitle2" gutterBottom>
                  {t(
                    "deliveryNote.deliveryDetails.tab.deliveryNoteInfo.noDamageForms"
                  )}
                </Mui.Typography>
              </Mui.Grid>
            )}
          </Mui.Grid> */}

          <Mui.Typography variant="h6">
            {t("deliveryNote.deliveryDetails.tab.deliveryNoteInfo.openDamages")}
          </Mui.Typography>
          <Mui.Grid
            container
            key={`vehicles-damage-grid-content-${props.index}`}
            columns={12}
            alignItems="center"
            spacing={2}
            rowGap={2}
            padding={damages?.length > 0 ? 2 : 0}
          >
            {damages !== undefined && damages.length > 0 ? (
              damages.map((damage, i) => {
                return (
                  <Mui.Grid
                    key={`damage-${damage.damageFormId}-${damage.id}`}
                    item
                    xs={12} sm={12} md={6} lg={3} xl={3}
                  >
                    <li>
                      <Mui.Typography variant="bodySmall">
                      {`${damage.label} - ${damage.severity}`}
                      </Mui.Typography>
                    </li>
                  </Mui.Grid>
                );
              })
            ) : (
              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <Mui.Typography variant="subtitle2" gutterBottom>
                  {t("deliveryNote.deliveryDetails.tab.deliveryNoteInfo.noOpenDamage")}
                </Mui.Typography>
              </Mui.Grid>
            )}
          </Mui.Grid>

          <Mui.Typography variant="h6" mt={4}>
            {t("deliveryNote.deliveryDetails.tab.deliveryNoteInfo.missingEquipments")}
          </Mui.Typography>
          <Mui.Grid
            container
            key={`vehicles-damage-grid-content-${props.index}`}
            columns={12}
            alignItems="center"
            spacing={2}
            rowGap={2}
            padding={missingEquipments?.length > 0 ? 2 : 0}
          >
            {missingEquipments !== undefined && missingEquipments.length > 0 ? (
              missingEquipments.map((equipment, i) => {
                return (
                  <Mui.Grid
                    key={`equipment-${equipment.id}-${equipment.createDate}`}
                    item
                    xs={12} sm={12} md={6} lg={3} xl={3}
                  >
                    <li>
                      <Mui.Typography variant="bodySmall">
                        {equipment.descr}
                      </Mui.Typography>
                    </li>
                  </Mui.Grid>
                );
              })
            ) : (
              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <Mui.Typography variant="subtitle2" gutterBottom>
                  {t("deliveryNote.deliveryDetails.tab.deliveryNoteInfo.noMissingEquipments")}
                </Mui.Typography>
              </Mui.Grid>
            )}
          </Mui.Grid>
        </Mui.CardContent>
      </Mui.Card>
    </Mui.Box>
  );
}

export default DeliveryNoteVehiclesDetails;